import axios from 'axios';
import { getToken } from '@iso/lib/helpers/utility';
import { put } from 'redux-saga/effects';
import actions from '../../redux/auth/actions';
// const history = createBrowserHistory();
// const fakeApiCall = false; // auth0 or express JWT
const timeout = 600000;
const apiUrl = process.env.REACT_APP_API_URL;
// const systemId = process.env.REACT_APP_SYSTEM_ID;
// test change

let headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Access-Control-Allow-Origin': '*'
};

export function* get(uri, data, page, sort, token, roleAuth) {
  // this.checkToken();
  const sessionToken = getToken().get('idToken') ? getToken().get('idToken') : token ? token : null;

  headers = {
    ...headers,
    authorization: `Bearer ${sessionToken}`
  };
  if (roleAuth) {
    const based64RoleHeader = Buffer.from(roleAuth).toString('base64');
    headers = {
      ...headers,
      roleAuth: `${based64RoleHeader}`
    };
  }
  if (page) {
    headers = {
      ...headers,
      Range: `${page.page ? page.page : 0}-${page.limit ? page.limit : 10}`
    };
  }
  if (!sort) {
    sort = {
      sort: 'asc',
      sortBy: 'createdAt'
    };
  }
  const params = data ? toParams(data) : '';
  const sortField = `&sort=${sort.sort === 'asc' ? '' : '-'}${sort.sortBy}`;
  // // console.log('HEADERS', headers);
  // // console.log('URI', `${apiUrl}${uri}?${params}${sortField}`);
  return yield fetch(`${apiUrl}/${uri}?${params}${sortField}`, {
    headers: headers,
    method: 'GET'
  });
}

export function* post(uri, data, page, token, roleAuth) {
  const sessionToken = getToken().get('idToken') ? getToken().get('idToken') : token ? token : null;
  // console.log('sessionToken',sessionToken);

  if (page) {
    headers = {
      ...headers,
      authorization: `Bearer ${sessionToken}`,
      Range: `${page.page || 0}-${page.limit || 50}`
    };
  } else {
    headers = {
      ...headers,
      authorization: `Bearer ${sessionToken}`
    };
  }
  if (roleAuth) {
    const based64RoleHeader = Buffer.from(roleAuth).toString('base64');
    headers = {
      ...headers,
      roleAuth: `${based64RoleHeader}`
    };
  }
  data = {
    ...data
    // mqToken: sessionToken,
  };
  return yield fetch(`${apiUrl}/${uri}`, {
    headers: headers,
    method: 'POST',
    data
  });
}

export function* postTest(uri, data, page, token, roleAuth, header) {
  const sessionToken = getToken().get('idToken') ? getToken().get('idToken') : token ? token : null;
  // console.log('sessionToken',sessionToken);

  if (page) {
    headers = {
      ...headers,
      authorization: `Bearer ${sessionToken}`,
      Range: `${page.page || 0}-${page.limit || 50}`
    };
  } else {
    headers = {
      ...headers,
      authorization: `Bearer ${sessionToken}`
    };
  }
  if (roleAuth) {
    const based64RoleHeader = Buffer.from(roleAuth).toString('base64');
    headers = {
      ...headers,
      roleAuth: `${based64RoleHeader}`
    };
  }
  let testHeader = { ...header };
  if (header) {
    testHeader = {
      ...testHeader,
      ...header
    };
  }
  data = {
    ...data
  };

  return yield fetchTest(`${apiUrl}/${uri}`, {
    headers: testHeader,
    method: 'POST',
    data
  });
}
export function* postBlob(uri, data, token, roleAuth) {
  const sessionToken = getToken().get('idToken') ? getToken().get('idToken') : token ? token : null;
  // console.log('sessionToken',sessionToken);
  headers = {
    ...headers,
    authorization: `Bearer ${sessionToken}`
  };
  if (roleAuth) {
    const based64RoleHeader = Buffer.from(roleAuth).toString('base64');
    headers = {
      ...headers,
      roleAuth: `${based64RoleHeader}`
    };
  }
  return yield fetch(`${apiUrl}/${uri}`, {
    headers: headers,
    method: 'POST',
    data,
    responseType: 'blob'
  });
}
export function* PUT(uri, data, token, roleAuth) {
  const sessionToken = getToken().get('idToken') ? getToken().get('idToken') : token ? token : null;
  // console.log('sessionToken',sessionToken);
  headers = {
    ...headers,
    authorization: `Bearer ${sessionToken}`
  };
  if (roleAuth) {
    const based64RoleHeader = Buffer.from(roleAuth).toString('base64');
    headers = {
      ...headers,
      roleAuth: `${based64RoleHeader}`
    };
  }
  return yield fetch(`${apiUrl}/${uri}`, {
    headers: headers,
    method: 'PUT',
    data
  });
}

export function* patch(uri, data, token, roleAuth) {
  const sessionToken = getToken().get('idToken') ? getToken().get('idToken') : token ? token : null;
  // console.log('sessionToken',sessionToken);
  headers = {
    ...headers,
    authorization: `Bearer ${sessionToken}`
  };
  if (roleAuth) {
    const based64RoleHeader = Buffer.from(roleAuth).toString('base64');
    headers = {
      ...headers,
      roleAuth: `${based64RoleHeader}`
    };
  }
  return yield fetch(`${apiUrl}/${uri}`, {
    headers: headers,
    method: 'PATCH',
    data
  });
}

export function* DELETE(uri, data, token, roleAuth) {
  const sessionToken = getToken().get('idToken') ? getToken().get('idToken') : token ? token : null;
  // console.log('sessionToken',sessionToken);
  headers = {
    ...headers,
    authorization: `Bearer ${sessionToken}`
  };
  if (roleAuth) {
    const based64RoleHeader = Buffer.from(roleAuth).toString('base64');
    headers = {
      ...headers,
      roleAuth: `${based64RoleHeader}`
    };
  }
  return yield fetch(`${apiUrl}/${uri}`, {
    headers: headers,
    method: 'DELETE',
    data
  });
}

function toParams(data) {
  const url = Object.keys(data)
    .map(k => {
      return `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}`;
    })
    .join('&');
  return url;
}

function* forbidden() {
  yield localStorage.setItem('forbidToken', 1);
  yield put({
    type: actions.CHECK_AUTHORIZATION
  });
}

export function* fetch(url, options) {
  const result = yield axios
    .request({
      ...options,
      url,
      baseURL: apiUrl,
      timeout: timeout,
      headers: headers,
      onDownloadProgress: progress => {
        // const percentage = Math.round(
        //     (progress.loaded * 100) / progress.total
        //   );
        // console.log('download progress:', percentage);
      }
    })
    .then(res => {
      return res;
    })
    .catch(error => {
      return error;
    });
  if (result.status) {
    return result;
  } else {
    if (
      result.response.status === 401 ||
      result.response.status === 403 ||
      result.response.status === 498
    ) {
      yield forbidden();
    } else {
      if (result.response) {
        return result.response;
      }
    }
  }
}

export function* fetchTest(url, options) {
  const result = yield axios
    .request({
      ...options,
      url,
      baseURL: apiUrl,
      timeout: timeout,
      onDownloadProgress: progress => {}
    })
    .then(res => {
      return res;
    })
    .catch(error => {
      return error;
    });
  if (result.status) {
    return result;
  } else {
    if (
      result.response.status === 401 ||
      result.response.status === 403 ||
      result.response.status === 498
    ) {
      yield forbidden();
    } else {
      if (result.response) {
        return result.response;
      }
    }
  }
}
